<template>
    <div class="ec-card-unidade">
        <section class="ec-webhooks" :aria-label="'WebHooks da unidade ' + unidade.nomecompleto">
            <div class="ec-kpis" role="group" aria-label="Filtrar WebHooks por status">
                <button v-for="card in cardsStatus" :key="card.status" type="button"
                    class="ec-kpi" :class="['ec-kpi--'+card.cor, { ativo: statusAtivo==card.status }]"
                    :aria-pressed="statusAtivo==card.status ? 'true' : 'false'"
                    :title="'Listar os WebHooks com status ' + card.rotulo.toLowerCase()"
                    @click.prevent="filtraWebHooksStatus(card.status)">
                    <span class="ec-kpi__icone"><i :class="card.icone"></i></span>
                    <span class="ec-kpi__texto">
                        <span class="ec-kpi__rotulo">{{ card.rotulo }}</span>
                        <span class="ec-kpi__valor">{{ formatarNumero(card.total) }}</span>
                    </span>
                </button>
            </div>

            <div class="ec-webhooks__barra">
                <div class="ec-webhooks__titulo">
                    <span>WebHooks</span>
                    <span class="ec-status" :class="'ec-status--'+cardAtivo.cor">
                        <i :class="cardAtivo.icone"></i> {{ cardAtivo.rotulo }}
                    </span>
                    <span v-if="resumoPaginacao" class="ec-webhooks__contagem">{{ resumoPaginacao }}</span>
                </div>
                <div class="ec-webhooks__comandos">
                    <!-- botões "Exibição" e "Exportar" do v-ec-datatable -->
                    <div class="ec-webhooks__ferramentas"></div>
                    <button type="button" class="btn btn-sm btn-outline-primary" :disabled="carregando" @click="atualizarLista()">
                        <i class="fa-solid fa-rotate mr-1" :class="{ 'fa-spin': carregando }"></i> Atualizar
                    </button>
                </div>
            </div>

            <div class="ec-listagem">
                <div class="table-responsive ec-listagem__rolagem" :class="{ 'ec-listagem__rolagem--carregando': carregando && temWebHooks }" :aria-busy="carregando ? 'true' : 'false'">
                    <table v-ec-datatable="opcoesTabela" class="table table-sm table-hover ec-tabela mb-0">
                        <thead class="ec-thead">
                            <tr>
                                <th class="text-center" data-ec-prioridade="6">ID</th>
                                <th class="text-left">Inscrito / turma</th>
                                <th class="text-center" data-ec-prioridade="1">Status</th>
                                <th class="text-left" data-ec-prioridade="2">Evento</th>
                                <th class="text-center" data-ec-prioridade="4">Notas</th>
                                <th class="text-center" data-ec-prioridade="3">Recebido</th>
                                <th class="text-center" data-ec-prioridade="5">Atualizado</th>
                                <th class="ec-tabela__col-acoes">Ações</th>
                            </tr>
                        </thead>
                        <!-- primeira carga: linhas esqueleto -->
                        <tbody v-if="carregando && !temWebHooks">
                            <tr v-for="n in 3" :key="'esqueleto'+n" class="ec-tabela__esqueleto">
                                <td v-for="c in 8" :key="c"><span></span></td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="temWebHooks">
                            <tr v-for="aluno_captado in web_hooks.data" :key="aluno_captado.id">
                                <td class="text-center ec-webhooks__id" data-label="ID">#{{ aluno_captado.id }}</td>
                                <td class="text-left ec-webhooks__inscrito" data-label="Inscrito / turma">
                                    <span class="ec-webhooks__nome" :title="aluno_captado.nomeinscrito">{{ aluno_captado.nomeinscrito || 'Sem nome' }}</span>
                                    <span class="ec-webhooks__turma" :title="aluno_captado.descricaocompleta">
                                        <span v-if="aluno_captado.turma_deleted_at!=null" class="ec-status ec-status--erro ec-status--mini">Turma excluída</span>
                                        {{ aluno_captado.descricaocompleta || 'Turma não encontrada' }}
                                        <template v-if="aluno_captado.contatoid"> · CRM {{ aluno_captado.contatoid }}</template>
                                    </span>
                                </td>
                                <td class="text-center" data-label="Status">
                                    <span class="ec-status" :class="'ec-status--'+corStatus(aluno_captado)" :title="aluno_captado.processado==1 ? 'Processado' : 'Ainda não processado'">
                                        {{ getEstyloDescricaoStatusRequisicao(aluno_captado) || (aluno_captado.processado==1 ? 'PROCESSADO' : 'AGUARDANDO') }}
                                    </span>
                                </td>
                                <td class="text-left" data-label="Evento">
                                    <span class="ec-tabela__principal">{{ tipoEvento(aluno_captado) }}</span>
                                    <small v-if="aluno_captado.origem_inclusao" class="ec-tabela__secundario">{{ aluno_captado.origem_inclusao }}</small>
                                </td>
                                <td class="text-center" data-label="Notas">
                                    <a :href="'/Access/Unity/Unitie/'+unidade.id+'/notificacoes/webhook/'+aluno_captado.id" target="_blank"
                                        class="ec-notas" :class="{ 'ec-notas--pendentes': aluno_captado.qtd_notificacoes_nao_lidas>0 }"
                                        :title="(aluno_captado.qtd_notificacoes_nao_lidas || 0) + ' notificação(ões) não lida(s)'"
                                        :aria-label="(aluno_captado.qtd_notificacoes_nao_lidas || 0) + ' notificação(ões) não lida(s)'">
                                        <i class="fa-regular fa-bell" aria-hidden="true"></i> {{ aluno_captado.qtd_notificacoes_nao_lidas || 0 }}
                                    </a>
                                </td>
                                <td class="text-center ec-webhooks__data" data-label="Recebido" :title="daraHoraBrasileiro(aluno_captado.created_at)">{{ dataCurta(aluno_captado.created_at) }}</td>
                                <td class="text-center ec-webhooks__data" data-label="Atualizado" :title="daraHoraBrasileiro(aluno_captado.updated_at)">{{ dataCurta(aluno_captado.updated_at) }}</td>
                                <td class="ec-tabela__col-acoes">
                                    <div class="ec-acoes">
                                        <a v-if="aluno_captado.turma_deleted_at==null" :href="'/Access/Unity/Unitie/'+unidade.id+'/captacao/wh/'+aluno_captado.id"
                                            class="btn btn-sm ec-acao ec-acao--destaque" v-b-tooltip.hover title="Ver detalhes do WebHook" aria-label="Ver detalhes do WebHook">
                                            <i class="fa-solid fa-eye" aria-hidden="true"></i>
                                        </a>
                                        <!-- botão desabilitado não dispara tooltip: o span recebe o hover -->
                                        <span v-else class="d-inline-flex" v-b-tooltip.hover title="A turma deste WebHook foi excluída">
                                            <button type="button" class="btn btn-sm ec-acao" disabled aria-label="Ver detalhes indisponível: turma excluída">
                                                <i class="fa-solid fa-eye-slash" aria-hidden="true"></i>
                                            </button>
                                        </span>
                                        <button v-if="aluno_captado.processado==1 && aluno_captado.turma_deleted_at==null" type="button"
                                            class="btn btn-sm ec-acao" v-b-tooltip.hover title="Reprocessar WebHook" aria-label="Reprocessar WebHook"
                                            :disabled="!!processando[aluno_captado.id]" @click="modalReprocessamentoWebHook(aluno_captado)">
                                            <span v-if="processando[aluno_captado.id]=='reprocessar'" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            <i v-else class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
                                        </button>
                                        <button v-if="podeEnviarParaFila(aluno_captado)" type="button"
                                            class="btn btn-sm ec-acao" v-b-tooltip.hover title="Enviar para a fila de processamento" aria-label="Enviar para a fila de processamento"
                                            :disabled="!!processando[aluno_captado.id]" @click="enviaParaFilaTrabalhos(aluno_captado)">
                                            <span v-if="processando[aluno_captado.id]=='fila'" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            <i v-else class="fa-regular fa-paper-plane" aria-hidden="true"></i>
                                        </button>
                                        <button v-if="usuarioLogado.perfil_usuario==1" type="button"
                                            class="btn btn-sm ec-acao ec-acao--perigo" v-b-tooltip.hover title="Excluir WebHook" aria-label="Excluir WebHook"
                                            :disabled="!!processando[aluno_captado.id]" @click="MensagemExcluirWebHook(aluno_captado)">
                                            <span v-if="processando[aluno_captado.id]=='excluir'" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                            <i v-else class="fa-solid fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8" class="ec-tabela__estado">
                                    <i :class="cardAtivo.icone" class="fa-2x" aria-hidden="true"></i>
                                    <p>
                                        <strong>Nenhum WebHook {{ cardAtivo.rotuloVazio }}</strong><br>
                                        <small>Escolha outro indicador acima para ver os demais status.</small>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- rodapé padrão: "Mostrando x–y de z" + páginas (paginação no servidor) -->
                <ec-paginacao :paginacao="web_hooks" rotulo-itens="WebHooks" :carregando="carregando"
                    @ir="irParaPagina"></ec-paginacao>
            </div>
        </section>

        <div class="row">
            <div class="col-md-12">
                <details class="ec-card" :id="'totalizadodes_inscricao_'+unidade.id">
                    <summary class="ec-card__cabecalho">
                        <span class="ec-card__icone"><i class="fa-solid fa-chart-column"></i></span>
                        <div class="ec-card__textos">
                            <h3 class="ec-card__titulo">Processos e ofertas por ano</h3>
                            <p class="ec-card__subtitulo">Clique para ver a evolução anual</p>
                        </div>
                    </summary>
                    <div class="ec-card__corpo ec-card__corpo--flush">
                        <div class="ec-graficos" v-if="unidade.oferta_Inscricao_web==1">
                            <grafico-anual
                                titulo="Processos de inscrição web"
                                subtitulo="Total de processos por ano"
                                :itens="itensAnuais(totalInsc, 'ano')"
                                :total-informado="insc.length"
                                rotulo-valor="processo" rotulo-valor-plural="processos"
                                texto-link="Ver ofertas"
                                @abrir="OfertaInscricaoWeb()"
                            ></grafico-anual>
                            <grafico-anual
                                titulo="Ofertas de inscrição web"
                                subtitulo="Turmas ofertadas por ano de início"
                                :itens="itensAnuais(totalTurmasInsc, 'anoinicio')"
                                :total-informado="turmasInsc.length"
                                rotulo-valor="oferta" rotulo-valor-plural="ofertas"
                                texto-link="Ver ofertas"
                                @abrir="OfertaInscricaoWeb()"
                            ></grafico-anual>
                        </div>

                        <template v-if="unidade.oferta_processo_seletivo==1">
                            <h4 class="ec-graficos__secao">Processos seletivos</h4>
                            <div class="ec-graficos">
                                <grafico-anual
                                    titulo="Processos seletivos web"
                                    subtitulo="Total de processos por ano"
                                    :itens="itensAnuais(totalPse, 'ano')"
                                    :total-informado="pses.length"
                                    rotulo-valor="processo" rotulo-valor-plural="processos"
                                    texto-link="Ver ofertas"
                                    @abrir="OfertaProcessoSeletivo()"
                                ></grafico-anual>
                                <grafico-anual
                                    titulo="Ofertas de processos seletivos"
                                    subtitulo="Turmas ofertadas por ano de início"
                                    :itens="itensAnuais(totalTurmasPse, 'anoinicio')"
                                    :total-informado="turmasPse.length"
                                    rotulo-valor="oferta" rotulo-valor-plural="ofertas"
                                    texto-link="Ver ofertas"
                                    @abrir="OfertaProcessoSeletivo()"
                                ></grafico-anual>
                            </div>
                        </template>
                    </div>
                </details>
            </div>
        </div>
    </div>
</template>

<script>
import GraficoAnual from './GraficoAnual.vue'

export default {
    name: 'CardDashBoard',
    components: { GraficoAnual },
    props:['unidade','usuarioLogado','insc','pses','totalPse','totalInsc','turmasPse','turmasInsc','totalTurmasPse','totalTurmasInsc','totalPending','totalError','totalSuccess','totalRepetidos','totalSemProcessamento','mostrarLoading'],
    data(){
        return{
            statusAtivo:'sem_processamento',
            url_requisicao:'/api/v1/Crm/getWebHookConfirmadosUnityStatus/',
            web_hooks:{data:[]},
            carregando:false,
            observador:null,
            // ação em andamento por WebHook ({ [id]: 'reprocessar' | 'fila' | 'excluir' })
            processando:{},
            PendingTotal:null,
            ErrorTotal:null,
            SuccessTotal:null,
            RepetidosTotal:null,
            SemProcessamentoTotal:null
        }
    },
    computed:{
        cardsStatus(){
            return [
                { status:'sem_processamento', rotulo:'Aguardando', rotuloVazio:'aguardando processamento', cor:'aguardando', icone:'fa-solid fa-hourglass-half', total:this.SemProcessamentoTotal ?? 0 },
                { status:'pending', rotulo:'Pendente', rotuloVazio:'pendente', cor:'pendente', icone:'fa-solid fa-clock-rotate-left', total:this.PendingTotal ?? 0 },
                { status:'error', rotulo:'Erro', rotuloVazio:'com erro', cor:'erro', icone:'fa-solid fa-triangle-exclamation', total:this.ErrorTotal ?? 0 },
                { status:'success', rotulo:'Sucesso', rotuloVazio:'processado com sucesso', cor:'sucesso', icone:'fa-solid fa-circle-check', total:this.SuccessTotal ?? 0 },
                { status:'repetidos', rotulo:'Repetidos', rotuloVazio:'repetido', cor:'repetidos', icone:'fa-solid fa-clone', total:this.RepetidosTotal ?? 0 },
            ]
        },
        cardAtivo(){
            return this.cardsStatus.find(card => card.status == this.statusAtivo) || this.cardsStatus[0]
        },
        // v-ec-datatable em modo servidor: a API pagina; os cards de status filtram
        opcoesTabela(){
            return {
                servidor: true,
                id: 'dashboard-webhooks',
                filtros: false,
                ferramentas: '.ec-webhooks__ferramentas',
                exportar: this.exportarWebHooks,
                nomeArquivo: 'webhooks ' + this.cardAtivo.rotulo,
            }
        },
        temWebHooks(){
            return !!(this.web_hooks.data && this.web_hooks.data.length>0)
        },
        // "1–10 de 254"
        resumoPaginacao(){
            if(!this.temWebHooks || !this.web_hooks.total){
                return ''
            }
            return this.web_hooks.from + '–' + this.web_hooks.to + ' de ' + this.formatarNumero(this.web_hooks.total)
        },
    },
    created(){
        this.PendingTotal = this.totalPending.total;
        this.ErrorTotal = this.totalError.total;
        this.SuccessTotal = this.totalSuccess.total;
        this.RepetidosTotal = this.totalRepetidos.total;
        this.SemProcessamentoTotal = this.totalSemProcessamento.total;
    },
    mounted() {
        // a lista de webhooks só é buscada quando o card aparece na tela
        // (unidades recolhidas ou fora da área visível não disparam requisição)
        if('IntersectionObserver' in window){
            this.observador = new IntersectionObserver(entradas => {
                if(entradas.some(entrada => entrada.isIntersecting)){
                    this.observador.disconnect();
                    this.observador = null;
                    this.filtraWebHooksStatus('sem_processamento');
                }
            }, { rootMargin: '200px' });
            this.observador.observe(this.$el);
        }else{
            this.filtraWebHooksStatus('sem_processamento');
        }
    },
    beforeDestroy() {
        if(this.observador){
            this.observador.disconnect();
        }
    },
    methods:{
        // converte as listas de totais da API ([{ano|anoinicio, qtd}]) no formato do grafico-anual
        itensAnuais(lista, campoAno){
            return (lista || []).map(item => ({ rotulo: item[campoAno], valor: Number(item.qtd) }))
        },
        formatarNumero(valor){
            return Number(valor || 0).toLocaleString('pt-BR')
        },
        // mensagem não bloqueante no canto da tela
        avisar(mensagem, variante = 'success'){
            this.$bvToast.toast(mensagem || 'Operação concluída.', {
                title: variante=='danger' ? 'Algo deu errado' : 'Tudo certo',
                variant: variante,
                solid: true,
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: 5000,
            })
        },
        confirmar(mensagem, titulo, textoOk, varianteOk = 'primary'){
            return this.$bvModal.msgBoxConfirm(mensagem, {
                title: titulo,
                okTitle: textoOk,
                cancelTitle: 'Cancelar',
                okVariant: varianteOk,
                cancelVariant: 'outline-secondary',
                centered: true,
                footerClass: 'p-2',
            })
        },
        marcarProcessando(web_hook, acao){
            if(acao){
                this.$set(this.processando, web_hook.id, acao)
            }else{
                this.$delete(this.processando, web_hook.id)
            }
        },
        podeEnviarParaFila(web_hook){
            return web_hook.processado==0 && web_hook.tipoeventoaviso=='c' && web_hook.enviado_job==0 && web_hook.turma_deleted_at==null
        },
        enviaParaFilaTrabalhos(web_hook){
            this.confirmar('O WebHook #'+web_hook.id+' de '+(web_hook.nomeinscrito || 'inscrito sem nome')+' será enviado para a fila de processamento.', 'Enviar para a fila?', 'Enviar')
                .then(confirmado => {
                    if(confirmado){
                        this.sendWebhookJob(web_hook);
                    }
                })
        },
        modalReprocessamentoWebHook(web_hook){
            this.confirmar('O WebHook #'+web_hook.id+' de '+(web_hook.nomeinscrito || 'inscrito sem nome')+' voltará para a fila de processamento.', 'Reprocessar WebHook?', 'Reprocessar')
                .then(confirmado => {
                    if(confirmado){
                        this.reprocessWebhook(web_hook);
                    }
                })
        },
        sendWebhookJob(web_hook){
            let url='/api/v1/Crm/Unity/'+this.unidade.id+'/sendWebHookJob/webhook'
            let formData = new FormData();
            formData.append('_method','post');
            formData.append('web_hook', web_hook.id)

            this.marcarProcessando(web_hook, 'fila')
            axios.post(url, formData)
                .then(response => {
                    if(response.data.erro==false){
                        web_hook.enviado_job = 1;
                        this.avisar(response.data.mensagem)
                    }else{
                        this.avisar(response.data.mensagem || 'Não foi possível enviar o WebHook para a fila.', 'danger')
                    }
                })
                .catch(errors => {
                    console.log(errors.response && errors.response.data)
                    this.avisar('Houve um erro ao enviar o WebHook para a fila de processamento.', 'danger')
                })
                .finally(() => this.marcarProcessando(web_hook, null))
        },
        reprocessWebhook(web_hook){
            let url='/api/v1/Crm/Unity/'+this.unidade.id+'/resend/webhook'
            let formData = new FormData();
            formData.append('_method','post');
            formData.append('web_hook', web_hook.id)

            this.marcarProcessando(web_hook, 'reprocessar')
            axios.post(url, formData)
                .then(response => {
                    if(response.data.erro==false){
                        this.SemProcessamentoTotal = response.data.total
                        this.getWebHookConfirmadosUnityStatus();
                        this.avisar('WebHook #'+web_hook.id+' enviado para reprocessamento.')
                    }else{
                        this.avisar(response.data.mensagem || 'Não foi possível reprocessar o WebHook.', 'danger')
                    }
                })
                .catch(errors => {
                    console.log(errors.response && errors.response.data)
                    this.avisar('Houve um erro ao enviar o WebHook para reprocessamento.', 'danger')
                })
                .finally(() => this.marcarProcessando(web_hook, null))
        },
        MensagemExcluirWebHook(web_hook){
            this.confirmar('O WebHook #'+web_hook.id+' de '+(web_hook.nomeinscrito || 'inscrito sem nome')+' será excluído.', 'Excluir WebHook?', 'Excluir', 'danger')
                .then(confirmado => {
                    if(confirmado){
                        this.excluirWebHook(web_hook);
                    }
                })
        },
        excluirWebHook(web_hook){
            this.marcarProcessando(web_hook, 'excluir')
            axios({ method: 'delete', url: '/api/v1/Crm/webhook/'+web_hook.id })
                .then(response => {
                    this.avisar(response.data.mensagem, response.data.error==false ? 'success' : 'danger')
                    // recarrega só depois da resposta, para a lista já vir sem o WebHook excluído
                    this.atualizarLista()
                })
                .catch(error => {
                    console.log(error)
                    this.avisar('Houve um erro ao excluir o WebHook.', 'danger')
                })
                .finally(() => this.marcarProcessando(web_hook, null))
        },
        corStatus(web_hook){
            const classe = this.getEstyloStatusInscricao(web_hook) || ''
            if(classe.includes('alert-success')){
                return 'sucesso'
            }else if(classe.includes('alert-danger')){
                return 'erro'
            }else if(classe.includes('alert-primary')){
                return 'pendente'
            }
            return web_hook.processado==0 ? 'aguardando' : 'neutro'
        },
        tipoEvento(web_hook){
            const tipos = { c:'Inscrição confirmada', a:'Contrato assinado', m:'Matriculado', v:'Envia valor ao CRM', f:'Atualização cadastral', d:'Documentos' }
            return tipos[web_hook.tipoeventoaviso] || 'Outros'
        },
        getEstyloStatusInscricao(web_hook){
            if(web_hook.processado == 1 && ( ( (web_hook.status_inscricao=='success' || web_hook.status_post_contrato =='success' || web_hook.status_valormatricula=='success') && web_hook.requisicao_id>0 ) || (web_hook.status_atualizacao_cadastral=='success') || (web_hook.status=='success'))){
                return 'alert alert-success text-center'
            }else if (web_hook.processado == 1 && web_hook.status_inscricao=='error' && web_hook.requisicao_id>0){
                return 'alert alert-danger text-center'
            }else if(web_hook.processado==1 && web_hook.status_inscricao=='pending'){
                return 'alert alert-primary text-center'
            }
        },
        getEstyloDescricaoStatusRequisicao(aluno_captado){
            var status = (aluno_captado.tipoeventoaviso=='c' && aluno_captado.status_inscricao!=null ?
                    aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_post_contrato!=null ?
                        aluno_captado.status_post_contrato  : (aluno_captado.tipoeventoaviso=='a' && aluno_captado.status_inscricao!=null ?
                            aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='m' && aluno_captado.status_inscricao!=null ?
                                aluno_captado.status_inscricao : (aluno_captado.tipoeventoaviso=='v' && aluno_captado.status_valormatricula!=null ?
                                    aluno_captado.status_valormatricula : (aluno_captado.tipoeventoaviso=='f' && aluno_captado.status_atualizacao_cadastral!=null ?
                                        aluno_captado.status_atualizacao_cadastral : aluno_captado.status
                                    )
                                )
                            )
                        )
                    )
                )
            if(status==null || status==''){
                return '';
            }else if(status=='success' || status==2){
                return 'SUCESSO'
            }else if (status=='error' || status==3){
                return 'ERRO'
            }else if(status=='pending' || status==1){
                return 'PENDENTE'
            }else if(status=='warning' || status==4){
                return 'AVISO'
            }else {
                return status
            }
        },
        // v-ec-datatable: exporta todos os webhooks do status selecionado (lotes de 500)
        async exportarWebHooks({ colunas }){
            const valores = {
                'ID': wh => wh.id,
                'Inscrito / turma': wh => (wh.nomeinscrito || 'Sem nome') + ' · ' + (wh.descricaocompleta || 'Turma não encontrada'),
                'Status': wh => this.getEstyloDescricaoStatusRequisicao(wh) || (wh.processado==1 ? 'PROCESSADO' : 'AGUARDANDO'),
                'Evento': wh => this.tipoEvento(wh),
                'Notas': wh => wh.qtd_notificacoes_nao_lidas || 0,
                'Recebido': wh => this.daraHoraBrasileiro(wh.created_at),
                'Atualizado': wh => this.daraHoraBrasileiro(wh.updated_at),
            }
            const exportadas = colunas.filter(c => valores[c])
            const linhas = []
            let pagina = 1
            let ultima = 1
            do {
                const response = await axios.get(this.url_requisicao.split('?')[0], { params: { por_pagina: 500, page: pagina } })
                const dados = response.data.webhooks || {}
                ultima = dados.last_page || 1
                for(const wh of dados.data || []) linhas.push(exportadas.map(c => valores[c](wh)))
                pagina++
            } while(pagina <= ultima)
            return { cabecalho: exportadas, linhas }
        },
        // evento "ir" do ec-paginacao: (número da página, url do link do Laravel)
        irParaPagina(pagina, url){
            this.paginacaoConfirmados({ url: url, active: false })
        },
        paginacaoConfirmados(link){
            if(link.url && !link.active && !this.carregando){
                this.url_requisicao = link.url; // ajustando a url com parâmetros de pagina
                this.getWebHookConfirmadosUnityStatus();
            }
        },
        getWebHookConfirmadosUnityStatus(){
            this.carregando = true
            axios.get(this.url_requisicao)
                .then(response => {
                    if(response.data){
                        this.web_hooks = response.data.webhooks || {data:[]}

                        // atualiza o indicador do status listado com o total vindo da API
                        if(response.data.status=="success"){
                            this.SuccessTotal = response.data.total
                        }else if(response.data.status=="pending"){
                            this.PendingTotal = response.data.total
                        }else if(response.data.status=="error"){
                            this.ErrorTotal = response.data.total
                        }else if(response.data.status=="repetidos"){
                            this.RepetidosTotal = response.data.total
                        }else{
                            this.SemProcessamentoTotal = response.data.total
                        }
                    }
                })
                .catch(error => {
                    console.log('error',error);
                    this.avisar('Não foi possível carregar os WebHooks. Tente atualizar a lista.', 'danger')
                })
                .finally(() => {
                    this.carregando = false
                })
        },
        OfertaInscricaoWeb(){
            window.location.href = "/Access/Unity/Unitie/"+this.unidade.id+"/oferta_inscricao_web";
        },
        OfertaProcessoSeletivo(){
            window.location.href = "/Access/Unity/Unitie/"+this.unidade.id+"/oferta_processo_seletivo";
        },
        filtraWebHooksStatus(status){
            this.statusAtivo = status
            this.url_requisicao = '/api/v1/Crm/getWebHookConfirmadosUnityStatus/' + this.unidade.id +'/status/'+ status
            this.getWebHookConfirmadosUnityStatus();
        },
        // recarrega a página atual da lista do status selecionado
        atualizarLista(){
            this.getWebHookConfirmadosUnityStatus();
        },
        daraHoraBrasileiro(date){
            return date ? new Date(date).toLocaleString('pt-BR') : ''
        },
        dataCurta(date){
            return date ? new Date(date).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', year:'2-digit', hour:'2-digit', minute:'2-digit' }) : '—'
        },
    }
}
</script>
